import { createSlice } from '@reduxjs/toolkit';

export interface ConfirmationData {
  tickets: Array<{
    quantity: number;
    name: string;
    price: number;
  }>;
  total: number;
  paymentMethod: 'qr' | 'cash' | 'link';
  buyer?: {
    name: string;
    lastName: string;
    dni?: string;
    email?: string;
    phone?: string;
    profileImage?: string;
  } | null;
}

interface PaymentState {
  isLoading: boolean;
  isErrorMessage: string | null;
  statusCode: number | null;
  paymentData: any | null;
  paymentResult: any | null;
  confirmationData: ConfirmationData | null;
}

const initialState: PaymentState = {
  isLoading: false,
  isErrorMessage: null,
  statusCode: null,
  paymentData: null,
  paymentResult: null,
  confirmationData: null,
};

export const paymentSlice = createSlice({
  name: 'payment',
  initialState,
  reducers: {
    startLoadingPayment: (state) => {
      state.isLoading = true;
      state.isErrorMessage = null;
      state.statusCode = null;
    },
    stopLoadingPayment: (state) => {
      state.isLoading = false;
    },
    setPaymentError: (state, action) => {
      state.isLoading = false;
      state.isErrorMessage = action.payload.message || 'Error al procesar el pago';
      state.statusCode = action.payload.status || null;
      state.paymentResult = null;
    },
    setPaymentSuccess: (state, action) => {
      state.isLoading = false;
      state.isErrorMessage = null;
      state.statusCode = action.payload.status || 200;
      state.paymentResult = action.payload.data;
    },
    setPaymentData: (state, action) => {
      state.paymentData = action.payload;
    },
    setConfirmationData: (state, action) => {
      state.confirmationData = action.payload;
    },
    resetPaymentState: (state) => {
      state.isLoading = false;
      state.isErrorMessage = null;
      state.statusCode = null;
      state.paymentData = null;
      state.paymentResult = null;
      state.confirmationData = null;
    },
  },
});

export const {
  startLoadingPayment,
  stopLoadingPayment,
  setPaymentError,
  setPaymentSuccess,
  setPaymentData,
  setConfirmationData,
  resetPaymentState,
} = paymentSlice.actions;

export default paymentSlice.reducer;

